/** "Good morning" / "Good afternoon" / "Good evening" by the device's clock (D80). */
export function greeting(hour = new Date().getHours()): string {
  if (hour < 5 || hour >= 18) return "Good evening";
  return hour < 12 ? "Good morning" : "Good afternoon";
}
